import React from "react";

const PhysicalHealth = ({ formData, handleChange, setActiveTab, errors = {}, onNext }) => {
    return (
        <div id="physical-health" className="content">
            <div className="row g-3 justify-content-center">
                {/* Known medical conditions */}
                <div className="col-md-12">
                    <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
                        Known medical conditions?
                    </small>
                    <div className="checkbox-group d-flex justify-content-center">
                        {["Yes", "No"].map((option) => {
                            const inputId = `medicalConditions-${option}`;
                            return (
                                <div className="form-check form-check-inline mb-2" key={option}>
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        id={inputId}
                                        name="medicalConditions"
                                        value={option}
                                        checked={formData.medicalConditions === option}
                                        onChange={handleChange}
                                    />
                                    <label className="form-check-label" htmlFor={inputId}>
                                        {option}
                                    </label>

                                    {option === "Yes" && formData.medicalConditions === "Yes" && (
                                        <div className="form-floating form-floating-outline mt-2">
                                            <input
                                                type="text"
                                                className={`form-control ${errors.medicalConditionsDetails ? 'is-invalid' : ''}`}
                                                name="medicalConditionsDetails"
                                                value={formData.medicalConditionsDetails}
                                                onChange={handleChange}
                                                placeholder="(please specify)"
                                            />
                                            <label>(please specify)</label>
                                            {errors.medicalConditionsDetails && (
                                                <div className="invalid-feedback">{errors.medicalConditionsDetails}</div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                    {errors.medicalConditions && (
                        <small className="text-danger d-block text-center mt-2">{errors.medicalConditions}</small>
                    )}
                </div>
                {/* Experienced issues */}
                <div className="col-md-12">
                    <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
                        Has the individual experienced any of the following?
                    </small>
                    <div className="row">
                        {[
                            "High Blood Pressure",
                            "Diabetes",
                            "Heart Disease",
                            "Respiratory Issues",
                            "Weight Issues",
                            "Other",
                        ].map((option) => {
                            const inputId = `healthIssues-${option.replace(/\s+/g, '-')}`;
                            return (
                                <div className="col-md-6 mb-2" key={option}>
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id={inputId}
                                            name="healthIssues"
                                            value={option}
                                            checked={formData.healthIssues.includes(option)}
                                            onChange={handleChange}
                                        />
                                        <label className="form-check-label ms-1" htmlFor={inputId}>
                                            {option}
                                        </label>

                                        {option === "Other" && formData.healthIssues.includes("Other") && (
                                            <div className="form-floating form-floating-outline mt-2">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="otherHealthIssue"
                                                    value={formData.otherHealthIssue}
                                                    onChange={handleChange}
                                                    placeholder="Other"
                                                />
                                                <label>Other</label>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
                {/* Brief History of Illness */}
                <div className="col-md-12">
                    <div className="form-floating form-floating-outline mb-3">
                        <textarea
                            className={`form-control h-100 ${errors.illnessHistory ? 'is-invalid' : ''}`}
                            name="illnessHistory"
                            value={formData.illnessHistory}
                            onChange={handleChange}
                            placeholder="Brief History of Illness"
                            rows="4"
                        ></textarea>
                        <label>Brief History of Illness</label>
                        {errors.illnessHistory && (
                            <div className="invalid-feedback">{errors.illnessHistory}</div>
                        )}
                    </div>
                </div>
                {/* Expectations */}
                <div className="col-md-12">
                    <div className="form-floating form-floating-outline mb-3">
                        <textarea
                            className={`form-control h-100 ${errors.expectations ? 'is-invalid' : ''}`}
                            name="expectations"
                            value={formData.expectations}
                            onChange={handleChange}
                            placeholder="Expectations from Rehabilitation Services"
                            rows="4"
                        ></textarea>
                        <label>Expectations from Rehabilitation Services</label>
                        {errors.expectations && (
                            <div className="invalid-feedback">{errors.expectations}</div>
                        )}
                    </div>
                </div>
                {/* Navigation Buttons */}
                <div className="col-12 d-flex justify-content-end mt-2">
                    <div className="col-md-2">
                        <button
                            type="button"
                            className="btn btn-outline-secondary btn-sm btn-prev w-100"
                            onClick={() => setActiveTab("medications")}
                        >
                            <i className="ri-arrow-left-line"></i> Previous
                        </button>
                    </div>
                    <div className="col-md-2">
                        <button
                            type="button"
                            className="btn btn-primary btn-sm btn-next ms-2 w-100"
                            onClick={onNext}
                        >
                            Next <i className="ri-arrow-right-line"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PhysicalHealth;